import gql from 'graphql-tag'

export const notificationSettings = gql`
  query NotificationSettings($workspaceId: Float!) {
    notificationSettings(workspace_id: $workspaceId) {
      notification_settings
    }
  }
`
